import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MetroToastService, MetroToast } from '../../services/metro-toast.service';

@Component({
  selector: 'app-metro-toast-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './metro-toast-banner.component.html',
  styleUrls: ['./metro-toast-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetroToastBannerComponent {
  private toastService = inject(MetroToastService);

  readonly toasts = signal<MetroToast[]>([]);

  constructor() {
    this.toastService.toasts$.subscribe(list => this.toasts.set(list));
  }

  remove(id: number) {
    this.toastService.remove(id);
  }

  trackById = (_: number, toast: MetroToast) => toast.id;

  ariaLive = computed(() => (this.toasts().some(t => t.severity === 'error' || t.severity === 'warning') ? 'assertive' : 'polite'));
}
